
































































import { Component, Prop, Watch } from 'vue-property-decorator';
import _ from 'lodash';

import AppVue from '@/AppVue.vue';
import {
  SkillsStrategyModel,
  StrategyLookupModel,
  StrategyGridModel,
  StrategyGridRowModel,
  QuestionnaireLookups,
} from '@/core/models';

@Component
export default class StrategyGridCpt extends AppVue {
  @Prop() lookups: QuestionnaireLookups;
  @Prop() strategies: SkillsStrategyModel[];
  @Prop() criticalSkillName: string;
  @Prop({ default: false }) disabled: boolean;

  gridModel: StrategyGridModel;
  someBla = true;

  @Watch('strategies')
  private onStrategiesChange() {
    this.loadGridModel();
  }

  async created() {
    this.loadGridModel();
  }

  private loadGridModel() {
    this.gridModel = this.createStrategiesGridModel(this.strategies);
    // this is needed for accessibility, element ui checkboxes add a label with tabindex
    // so both the checkbox and the label are focusable, which is not correct
    // and can cause confusion for screen readers
    this.removeTabindexCheckbox();
  }

  private removeTabindexCheckbox() {
    this.$nextTick(() => {
      // Select all label elements with .el-checkbox class
      document.querySelectorAll('label.el-checkbox').forEach(label => {
        // Remove tabindex if present
        if (label.hasAttribute('tabindex')) {
          label.removeAttribute('tabindex');
        }

        // Also remove from any child elements with tabindex (defensive approach)
        label.querySelectorAll('[tabindex]').forEach(el => {
          el.removeAttribute('tabindex');
        });
      });
    });
  }

  getRowClass({ row, rowIndex }: any) {
    return row.strategies ? 'el-table__row' : 'strategy-type-heading';
  }

  getHeading(label: string) {
    return label.split('(')[0];
  }

  getSubHeading(label: string) {
    return `(${label.split('(')[1]}`;
  }

  getTooltip(label: string) {
    return `${this.criticalSkillName}<br/>${this.getHeading(label)}`;
  }

  private createStrategiesGridModel(strategies: SkillsStrategyModel[]) {
    const rows: StrategyGridRowModel[] = [];
    _.each(this.lookups.strategyTypes, strategyType => {
      rows.push({
        rowText: strategyType.text,
      } as StrategyGridRowModel);

      rows.push(...this.createStrategyRows(strategies, strategyType.id));
    });

    return { rows } as StrategyGridModel;
  }

  private createStrategyRows(strategies: SkillsStrategyModel[], strategyTypeId: number) {
    const strategiesLookup = _.filter(this.lookups.strategies, {
      strategyTypeId,
    });

    return _.map(strategiesLookup, strategyLookup => {
      const row: StrategyGridRowModel = {
        rowText: this.getRowText(strategyLookup),
        strategies: this.createGridRow(strategies, strategyLookup.id),
      };

      return row;
    });
  }

  private getRowText(strategy: StrategyLookupModel) {
    return strategy.text || this.getStrategyTypeText(strategy.strategyTypeId);
  }

  private getStrategyTypeText(strategyTypeId: number) {
    const strategyType = _.find(this.lookups.strategyTypes, {
      id: strategyTypeId,
    });
    return strategyType ? strategyType.text : 'ERROR';
  }

  private createGridRow(strategies: SkillsStrategyModel[], strategyId: number) {
    const rowStrategies: SkillsStrategyModel[] = [];

    _.each(this.lookups.strategyLevels, strategyLevel => {
      rowStrategies[strategyLevel.id] = _.find(strategies, {
        strategyId,
        strategyLevelId: strategyLevel.id,
      }) as SkillsStrategyModel;
    });

    return rowStrategies;
  }
}
